import styled from "styled-components";
import addHeaders from "../../utils/addHeader";
import HConnectControl from "./HConnectControl";

// Setup Use of API
import useApi from '../../hooks/useApi';
import { useQuery } from '@tanstack/react-query'
import buildQueryString from "../../utils/api/buildQueryString";
import { qk } from "../../utils/queryKeys";

//This allows to return the data read from the select entities
import generateSetValueObject, { resetSetValueObject } from "./generateSetValueObject";

import useTranslation from "../../hooks/useTranslation";

//Setting up the Wrapper
const SelectContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
`

//HConnect takes an entity like 'customerGroup' a value like {name:'Domestic',id:'1'} a setter and options object.
const HConnect = ({
    id, entity, mainValueId,
    name,
    valueName,
    valueMap,
    setValue,
    options,
    isRed,
    modalTitle,
    placeholder,
    parentId,
    parentField,
    subObject,
    persistValue, // Added persistValue at root level
    testId,
    linkedFields,
    entityParams,
    autoOpen,
    inputId,
}) => {
    if (!options) { options = {} }

    let queryString = null;

    //If entityParams is defined, build the query string to get back the right data
    if (entityParams) {
        queryString = buildQueryString(entityParams, linkedFields);
    }

    let resolvedTestId = testId;
    if (typeof subObject === 'string' && subObject.trim() !== '' && testId) {
        const parts = testId.split('.');
        const index = parts.lastIndexOf('locationId');
        if (index !== -1) {
            parts.splice(index, 0, subObject);
            resolvedTestId = parts.join('.');
        }
    }

    //Setting up API 
    const { getMe } = useApi();
    const { t } = useTranslation();

    //Api Retrieval function to get list for the Entity
    const getData = async () => {
        let result
        const resource = queryString ? `${entity}${queryString}` : `${entity}`
        const response = await getMe(resource)
        if (response.data === undefined) {
            result = addHeaders([{ name: t('no.results.found'), unselectable: true }], false)
        } else {
            //This adds the headers if options.withHeaders is true
            result = addHeaders(response.data, options.withHeaders)
        }

        return result
    }

    //Return Data to Form
    const returnData = (data, valueMap) => {
        const result = generateSetValueObject(data, valueMap);
        setValue(result);
    }

    //Clear the field
    const clearField = () => {
        const result = resetSetValueObject(valueMap);
        setValue(result);
    }

    //Request to get data from API
    const result = useQuery({
        queryKey: qk.hconnect(entity, queryString),
        queryFn: getData,
        keepPreviousData: true
    })

    if (result.isError) return <span>{result.error?.message}</span>;

    return (
        <SelectContainer id='HConnectContainer'>
            <HConnectControl
                id={mainValueId}
                name={name}
                mainValueId={mainValueId}
                valueName={valueName}
                setValue={setValue}
                data={result.data}
                placeholder={placeholder}
                onSelect={selection => returnData(selection, valueMap)}
                entity={entity}
                modalTitle={modalTitle}
                options={options}
                isRed={isRed}
                $alwaysOn={true}
                parentId={parentId}
                parentField={parentField}
                persistValue={persistValue}
                testId={resolvedTestId}
                subObject={subObject}
                onClear={clearField}
                autoOpen={autoOpen}
                inputId={inputId}
            />
        </SelectContainer>
    );
};

export default HConnect;
